import rmskincareAPI from '../utils/rmskincareAPI'

const incomeApi = {
  //get
  //{  "id": 12,
  //   "amount": 100,
  //   "afterTax": 104.5,
  //   "tax": 4.5,
  //   "reason": {
  //     "id": 8,
  //     "name": "sales",
  //     "children": [],
  //     "parent": null
  //   },
  //   "paymentMethod": {
  //     "id": 1,
  //     "name": "Jessica-QuickPay",
  //     "info": "N/A",
  //     "tax": 0.045,
  //     "status": 1
  //   },
  //   "info": "4564",
  //   "comment": "test",
  //   "locked": false,
  //   "modifyByEmployee": {
  //     "id": 10,
  //     "firstName": "Admin",
  //     "lastName": "Test"
  //   },
  //   "status": 1,
  //   "recordDateTime": "2020/12/17 05:17:00",
  //   "createTime": "2020/12/24 16:33:50",
  //   "modifyTime": "2020/12/24 16:33:50"
  // }

  // Income
  searchSalesProfit: async (query) => {
    const result = await rmskincareAPI.get(`management/finance/payment${query}`)
    return result.data.data
  },

  searchCashInSummary:async (query) => {
    const result = await rmskincareAPI.get(`management/finance/payment/summary${query}`)
    return result.data.data
  },

  searchCommissionDetailReport: async (query) => {
    const result = await rmskincareAPI.get(
      `management/finance/report/commission${query}`
    )
    return result.data.data
  },

  searchCashSplitRecord: async (query) =>{
    const result = await rmskincareAPI.get(
      `management/finance/cash/split${query}`
    )
    return result.data.data
  },

  searchCashSplitRecordSum: async (query) =>{
    const result = await rmskincareAPI.get(
      `management/finance/cash/split/sum${query}`
    )
    return result.data.data
  },

  saveCashSplitRecord: async (requestBody) =>{
    const result = await rmskincareAPI.post(
      'management/finance/cash/split',
      requestBody
    )
    return result.data.data
  },

  deleteCashSplitRecord: async (cashId) =>{
    let result = await rmskincareAPI.delete(
      `management/finance/cash/split/${cashId}`
    )
    return result.data.data
  },


  // "id": "incomeId"
  // "status" : "lock"

  patchSalesProfitLocked: async (id, status) => {
    const result = await rmskincareAPI.patch(
      `management/finance/payment/lock/${id}?lock=${status}`
    )
    return result.data.date
  },

  patchSalesProfitUnlock: async (id, status) => {
    const result = await rmskincareAPI.patch(
      `management/finance/payment/lock/${id}?lock=${status}`
    )
    return result.data
  },

  patchSalesProfitFinish: async (id, status) => {
    const result = await rmskincareAPI.patch(
      `management/finance/payment/finish/${id}?finish=${status}`
    )
    return result.data
  },

  patchSalesProfitDCheck: async (id, status) => {
    const result = await rmskincareAPI.patch(
      `management/finance/payment/dcheck/${id}?dCheck=${status}`
    )
    return result.data
  },

  patchSalesProfitCCheck: async (id, status) => {
    const result = await rmskincareAPI.patch(
      `management/finance/payment/ccheck/${id}?cCheck=${status}`
    )
    return result.data
  },

  // importExcel
  // bankName: values.bankName,
  // endDate: values.endDate,
  // file: values.file,
  // startDate: values.startDate,
  // tableId: values.tableId,
  importBankTransaction: async (requestBody) => {
    const result = await rmskincareAPI.post(
      'management/finance/payment/import',
      requestBody
    )
    return result.data.data
  },

  getBankCategory: async (status) => {
    let result = await rmskincareAPI.get('management/bankreport/list')
    return result.data.data
  },

  incomeExport: async (startDate, endDate) => {
    let result = await rmskincareAPI
      .get(
        `management/finance/cashin/export?endDate=${endDate}&startDate=${startDate}`,
        { responseType: 'blob' }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'incomeReport.xlsx') //or any other extension
        document.body.appendChild(link)
        link.click()
      })
  },  
  updateCourseSalesByCourseId: async (cashInId,orderNumber,salesId) => {
    const result = await rmskincareAPI.post(
      `management/course/sales?cashInId=${cashInId}&orderNumber=${orderNumber}&salesId=${salesId}`,
    )
    return result.data.data
  },
  updateCourseTypeByCourseId: async (cashInId,orderNumber,groupId) => {
    const result = await rmskincareAPI.post(
      `management/course/type?cashInId=${cashInId}&orderNumber=${orderNumber}&groupId=${groupId}`,
    )
    return result.data.data
  },
  editSplitCashInPayment: async (requestBody) => {
    let result = await rmskincareAPI.put(
      `/management/finance/course/payment/split?cashInId=${requestBody.cashInId}`,
      requestBody.splitCashInDtos
    )
    return result.data.data
  },
}

export default incomeApi
